import React from 'react';
import StarOutlineIcon from '@mui/icons-material/StarOutline';

const starChipClass = [
  'group flex min-w-0 flex-1 cursor-pointer select-none flex-col items-center justify-center gap-1',
  'rounded-xl border border-slate-200 bg-white px-1 py-3 text-center text-xs leading-tight',
  'shadow-sm transition duration-200 hover:scale-105 hover:border-current hover:shadow-md active:scale-95',
  'sm:max-w-[104px] sm:text-sm',
].join(' ');

const StarRating = ({
  openHandler,
  experienceGetData,
}) => (
  <div className="mt-6">
    <div className="flex justify-center gap-1.5 sm:gap-3">
      <div className={`${starChipClass} text-red-600`} onClick={() => openHandler(1)}>
        <StarOutlineIcon className="!text-4xl cursor-pointer transition-transform duration-200 group-hover:scale-110" />
        <div>
          {experienceGetData?.five_star_1_rating_name}
        </div> 
      </div>

      <div className={`${starChipClass} text-orange-600`} onClick={() => openHandler(2)}>
        <StarOutlineIcon className="!text-4xl cursor-pointer transition-transform duration-200 group-hover:scale-110" />
        <div>
          {experienceGetData?.five_star_2_rating_name}
        </div> 
      </div>

      <div className={`${starChipClass} text-green-300`} onClick={() => openHandler(3)}>
        <StarOutlineIcon className="!text-4xl cursor-pointer transition-transform duration-200 group-hover:scale-110" />
        <div className="text-green-600">
          {experienceGetData?.five_star_3_rating_name}
        </div>
      </div>

      <div className={`${starChipClass} text-green-500`} onClick={() => openHandler(4)}>
        <StarOutlineIcon className="!text-4xl cursor-pointer transition-transform duration-200 group-hover:scale-110" />
        <div className="text-green-600">
          {experienceGetData?.five_star_4_rating_name}
        </div>
      </div>

      <div className={`${starChipClass} text-green-600`} onClick={() => openHandler(5)}>
        <StarOutlineIcon className="!text-4xl cursor-pointer transition-transform duration-200 group-hover:scale-110" />
        <div className="text-green-600">
          {experienceGetData?.five_star_5_rating_name}
        </div>
      </div>
    </div>
  </div>
);

export default StarRating;
